import { presentParticipantStatuses } from 'app/frontend/types/custom/EventParticipantStatus'

export const participantColor = (event: wowaudit.EventReference) => {
  const presentCount = event.participantReferences.filter((p) =>
    presentParticipantStatuses.includes(p.status),
  ).length

  const requiredCount = event.primaryDifficulty === 'mythic' ? 20 : 10
  if (presentCount >= requiredCount) return 'text-success-foreground'
  if (presentCount >= requiredCount * 0.8) return 'text-warning-foreground'
  return 'text-destructive-foreground'
}
